import React from 'react';
import styled from 'styled-components';
import Cards from 'components/Cards/Cards';
import RichText from 'components/RichText/index';

const PressHeroSection = ({ backgroundImg, title, description, ...otherProps }) => {
  return (
    <SectionContainer backgroundImg={backgroundImg} {...otherProps}>
      <div className="section-press-hero--wrapper">
        <div className="section-press-hero--container">
          <h1 className="section-press-hero--title">{title}</h1>
          <p className="section-press-hero--description">
            <RichText content={description.json} />
          </p>
          {otherProps.pressData.map((item, index) => {
            return (
              <div className="section-press-hero--dialog" key={index}>
                <Cards
                  bodyType={'simple'}
                  category={item.node.postDate}
                  title={item.node.postTitle || ''}
                  description={item.node.metaDescription.metaDescription || ''}
                  ctaTitle={'Learn more'}
                  ctaLink={`/press/${item.node.slug}`}
                />
              </div>
            );
          })}
        </div>
      </div>
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  background: white;

  .section-press-hero--wrapper {
    background: ${props => 'url(' + props.backgroundImg.file.url + ')'};
    background-repeat: no-repeat;

    background-size: 100% 480px;
  }

  .section-press-hero--container {
    margin: 0 auto;
    padding: 162px 28px 40px;

    .section-press-hero--title {
      font-weight: 900;
      font-size: 61px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      color: var(--white-color);
      max-width: 1195px;
      margin: 46px auto 0;
    }

    .section-press-hero--description {
      p {
        font-weight: 500;
        font-size: 20px;
        line-height: 150%;
        text-align: center;
        color: var(--white-color);
      }
      a {
        color: var(--white-color);
        font-weight: bold;
      }
      max-width: 784px;
      margin: 20px auto 40px auto;
    }

    .section-press-hero--dialog {
      background: var(--white-color);
      max-width: 1195px;
      margin: 30px auto 0;
    }
  }

  @media (max-width: 1190px) {
    .section-press-hero--container {
      .section-press-hero--dialog {
      }
    }
  }

  @media (max-width: 901px) {
    .section-press-hero--wrapper {
      background-size: auto 330px;
    }

    .section-press-hero--container {
      padding: 120px 28px 40px;

      .section-press-hero--title {
        font-size: 32px;
        letter-spacing: -0.03em;
        margin-top: 40px;
      }

      .section-press-hero--description {
        font-weight: 500;
        font-size: 17px;
        line-height: 150%;
        margin-top: 16px;
        max-width: 576px;
      }

      .section-press-hero--dialog {
        margin-top: 20px;
      }
    }
  }

  @media (max-width: 576px) {
    .section-press-hero--container {
      .section-press-hero--dialog {
        margin-top: 20px;
      }
    }
  }
`;

export default PressHeroSection;
